import React, { useState, Fragment, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingInForm from '../../components/LoadingInForm';
import Select from 'react-select';
import * as yup from 'yup';
import { Form, Col } from 'react-bootstrap';
import Button from '../../components/Button';
import If from '../../components/If';
import AlertError from '../../components/AlertError';
import AlertSuccess from '../../components/AlertSuccess';
import ConfirmationModal from '../../components/ConfirmationModal';
import { STRINGS } from '../../util/strings'	;
import { CulturaResult, MaterialResult, RegistroFitossanitarioForm, StateType } from '../../models/modelsRegistrosFitossanitarios';
import { PaisResult } from '../../models/modelsPaises';
import { STRINGS_REGISTROSFITOSSANITARIOS } from '../../util/registrosFitossanitarios/string';

import api from '../../services/api';

export default function RegistroFitossanitario() {
	const history = useHistory();
	const location = useLocation<StateType>();
	const [loading, setLoading] = useState<boolean>(false);
	const [success, setSuccess] = useState<boolean>(false);
	const [error, setError] = useState<any>(null);
	const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
	const [cultures, setCultures] = useState<CulturaResult[]>([]);
	const [enumMaterial, setEnumMaterial] = useState<CulturaResult[]>([]);
	const [paisOrigem, setPaisOrigem] = useState<PaisResult[]>([]);
	const [paisDestino, setPaisDestino] = useState<PaisResult[]>([]);

	const registroFitossanitarioSchema = yup.object().shape({
		nome: yup
			.string()
			.required(STRINGS.FORM_FIELD_REQUIRED),
		descricao: yup
			.string()
			.required(STRINGS.FORM_FIELD_REQUIRED),
		ativo: yup
			.boolean()
	})

	const initialValues: RegistroFitossanitarioForm = {
		culturaId: '',
		materialId: '',
		paisOrigemId: '',
		paisDestinoId: '',
		finalidade: '',
		restricao: '',
		organismos: '',
		formaCertificacao: ''
	}

	const { register, errors, handleSubmit, getValues, reset, control, formState: { isDirty } } = useForm({
		defaultValues: initialValues,
		mode: 'onTouched',
		//resolver: yupResolver(registroFitossanitarioSchema)
	})

	const getData = async () => {

		setLoading(true);

		try {
			const cultures = await api.get<CulturaResult[]>(`api/v1/Shipment/cultura_obter_ativos`);
			const material = await api.get<CulturaResult[]>(`api/v1/Shipment/material_obter_ativos`);
			const paises = await api.get<PaisResult[]>(`api/v1/Paises/`);

			if (cultures.status === 200)
				setCultures(cultures.data);

			if (material.status === 200)
				setEnumMaterial(material.data);

			if (paises.status === 200)
			{
				setPaisOrigem(paises.data);
				setPaisDestino(paises.data);
			}


		}
		catch (error: any) {
		}

		setLoading(false);
	}

	const getRegistroFitossanitario = async () => {

		try {
			const { data } = await api.get<RegistroFitossanitarioForm>(`api/v1/registros-fitossanitarios/RegistrosFitossanitarios/${location.state.id}`);

			const culturesReg = await api.get<CulturaResult[]>(`api/v1/Shipment/cultura_obter_ativos`);
			const materialReg = await api.get<CulturaResult[]>(`api/v1/Shipment/material_obter_ativos`);
			const paisesReg = await api.get<PaisResult[]>(`api/v1/Paises/`);

			let culturaDto = culturesReg.data.find(x => x.id === data.culturaId);
			let materialDto = materialReg.data.find(x => x.id === data.materialId);
			let paisOrigemDto = paisesReg.data.find(x => x.id === data.paisOrigemId);
			let paisDestinoDto = paisesReg.data.find(x => x.id === data.paisDestinoId);

			reset({
				culturaId: {
					label: culturaDto?.nome,
					value: culturaDto?.id,
				},
				materialId: {
					label: materialDto?.nome,
					value: materialDto?.id,
				},
				paisOrigemId: {
					label: paisOrigemDto?.nomePTBR,
					value: paisOrigemDto?.id,
				},
				paisDestinoId: {
					label: paisDestinoDto?.nomePTBR,
					value: paisDestinoDto?.id,
				},
				finalidade: data.finalidade,
				restricao: data.restricao,
				organismos: data.organismos,
				formaCertificacao: data.formaCertificacao,
			})


		}
		catch (error: any) {
		}
	}

	useEffect(() => {
		getData();
		getRegistroFitossanitario();
	}, [location.state.id, reset]);

	const onSubmit = async () => {
		setLoading(true);
		setError(null);

		try {
			const { status } = await api.put('api/v1/registros-fitossanitarios/RegistrosFitossanitarios/', {
				id: location.state.id,
				culturaId: getValues('culturaId')?.value,
				materialId: getValues('materialId')?.value,
				paisOrigemId: getValues('paisOrigemId')?.value,
				paisDestinoId: getValues('paisDestinoId')?.value,
				finalidade: getValues('finalidade'),
				restricao: getValues('restricao'),
				organismos: getValues('organismos'),
				formaCertificacao: getValues('formaCertificacao'),
			});

			if (status === 200 || status === 201) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
				setSuccess(true);

				setTimeout(() => {
					history.goBack();
				}, 3600);
			}
		} catch (error: any) {
			setError(error?.response?.data);
		}
		setLoading(false);
	}

	return <div className="container container-fluid">
		<If condition={success && !error}>
			<AlertSuccess
				message={STRINGS.ALERT_MESSAGE_SUCCESS}
			/>
		</If>
		<If condition={loading}>
			<LoadingInForm />
		</If>
		<If condition={!success && error !== null}>
			{error !== null && error.message.length > 0 ? error.message.map((errorE: string) => <AlertError message={errorE} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<h3>{STRINGS_REGISTROSFITOSSANITARIOS.REGISTER_REGISTROS_FITOSSANITARIOS}</h3>
		<Form onSubmit={handleSubmit(onSubmit)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Cultura
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Controller
						control={control}
						name="culturaId"
						isInvalid={errors.culturaId}
						as={<Select
							options={cultures.map(culture => Object.assign({ label: culture.nome, value: culture.id }))}
							placeholder="Selecione uma cultura"
							isClearable
						/>}
					/>
					<If condition={errors.culturaId}>
						<p className="error-field">{errors.culturaId?.message}</p>
					</If>
				</Form.Group>
				<Form.Group as={Col}>
					<Form.Label>
						Material
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Controller
						control={control}
						name="materialId"
						isInvalid={errors.materialId !== undefined}
						as={<Select
							placeholder="Selecione um material"
							options={enumMaterial.map(local => Object.assign({ value: local.id, label: local.nome }))}
							isClearable
						/>}
					/>
					<If condition={errors.materialId}>
						<p className="error-field">{errors.materialId?.message}</p>
					</If>
				</Form.Group>	
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						País de Origem
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Controller
						control={control}
						name="paisOrigemId"
						isInvalid={errors.paisOrigemId !== undefined}
						as={<Select
							placeholder="Selecione um país de origem"
							options={paisOrigem.map(local => Object.assign({ value: local.id, label: local.nomePTBR }))}
							isClearable
						/>}
					/>
					<If condition={errors.paisOrigemId}>
						<p className="error-field">{errors.paisOrigemId?.message}</p>
					</If>
				</Form.Group>
				<Form.Group as={Col}>
					<Form.Label>
						País de Destino<em>*</em>
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Controller
						control={control}
						name="paisDestinoId"
						isInvalid={errors.paisDestinoId !== undefined}
						as={<Select
							placeholder="Selecione um país de destino"
							options={paisDestino.map(local => Object.assign({ value: local.id, label: local.nomePTBR }))}
							isClearable
						/>}
					/>
					<If condition={errors.paisDestinoId}>
						<p className="error-field">{errors.paisDestinoId?.message}</p>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Finalidade
					</Form.Label>
					<Form.Control
						ref={register}
						name="finalidade"
						as="textarea"
						rows={4}
						placeholder="Insira a finalidade"
						isInvalid={errors.finalidade !== undefined}
						autoComplete="off"
					/>
					<If condition={errors.finalidade}>
						<Form.Control.Feedback type="invalid">
							{errors.finalidade?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Restrição
					</Form.Label>
					<Form.Control
						ref={register}
						name="restricao"
						as="textarea"
						rows={4}
						placeholder="Insira a restrição"
						isInvalid={errors.restricao !== undefined}
						autoComplete="off"
					/>
					<If condition={errors.restricao}>
						<Form.Control.Feedback type="invalid">
							{errors.restricao?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Organismos
					</Form.Label>
					<Form.Control
						ref={register}
						name="organismos"
						as="textarea"
						rows={4}
						placeholder="Insira os organismos"
						isInvalid={errors.organismos !== undefined}
						autoComplete="off"
					/>
					<If condition={errors.organismos}>
						<Form.Control.Feedback type="invalid">
							{errors.organismos?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Forma de Certificação
					</Form.Label>
					<Form.Control
						ref={register}
						name="formaCertificacao"
						as="textarea"
						rows={4}
						placeholder="Insira a forma de certificação"
						isInvalid={errors.formaCertificacao !== undefined}
						autoComplete="off"
					/>
					<If condition={errors.formaCertificacao}>
						<Form.Control.Feedback type="invalid">
							{errors.formaCertificacao?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<div className="button-position">
				<Button
					title="Cancelar"
					type="button"
					contained={false}
					onClick={() => {
						isDirty ? setIsConfirmation(true) :
							history.goBack();
					}}
				/>
				<Button
					title="Cadastrar"
					type="submit"
					contained={true}
				/>
			</div>
		</Form>
		<If condition={isConfirmation}>
			<ConfirmationModal
				show={isConfirmation}
				confirmationMsg={STRINGS_REGISTROSFITOSSANITARIOS.CONFIRM_LEFT_EDITION}
				cancelMsg={STRINGS_REGISTROSFITOSSANITARIOS.CANCEL_LEFT_EDITION}
				onConfirm={() => history.goBack()}
				onHide={() => setIsConfirmation(false)}
				title={STRINGS_REGISTROSFITOSSANITARIOS.EDITION_REGISTROS_FITOSSANITARIOS}
				type="button"
				variant="danger"
			>
				{STRINGS_REGISTROSFITOSSANITARIOS.EDITION_REGISTER_CONFIRMATION_CANCEL}
			</ConfirmationModal>
		</If>

	</div>;
}